<template>
  <div>
    <c-box
      title="Ежемесячные работы, которые проводятся на постоянной основе"
      :loading="loading"
      shadow
    >
      <ol v-if="!loading && Object.keys(data).length">
        <template>
          <li
            v-for="work of activeWorks"
            :key="work.id"
          >
            <p class="text-bold">
              {{ work.title }}
            </p>
            <p>{{ work.description }}</p>
            <hr>
          </li>
        </template>
      </ol>
      <no-data v-if="!loading && !Object.keys(data).length" />
    </c-box>
  </div>
</template>

<script>
import CBox from '../../../../../../../resources/js/components/ui/CBox.vue'
import NoData from '../../../../../../../resources/js/components/NoData.vue'
import diagramColors from '../../../../../../../resources/js/mixins/diagramColors'

export default {
  name: 'RegularWorks',
  components: { CBox, NoData },
  mixins: [diagramColors],
  props: {
    loading: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      works: [
        {
          id: 'РаботаПостоянная1_СборПозиций',
          title: 'Сбор позиций и анализ динамики в поисковых системах Яндекс и Google ',
          description: 'Еженедельно осуществляется сбор позиций и проводится аналитика динамики. Заключение по аналитике представлено в разделе 1 текущего отчета.'
        },
        {
          id: 'РаботаПостоянная2_СборДаныхПосещаемости',
          title: 'Сбор данных о посещаемости в различных разрезах и анализ динамики и структуры трафика',
          description: 'Еженедельно осуществляется сбор показателей посещаемости из систем аналитики и проводится аналитика динамики и структуры трафика. Заключение по аналитике представлено в разделах 2-10 текущего отчета.'
        },
        {
          id: 'РаботаПостоянная3_АнализКонкурентов',
          title: 'Анализ конкурентной среды в различных разрезах ',
          description: 'Собраны конкуренты из выдачи поисковых систем по семантическому ядру, построен рейтинг и выделены лидеры. Данная информация используется при аналитике достигнутых результатов и проведении работ по проработке всех факторов ранжирования.'
        },
        {
          id: 'РаботаПостоянная4_АнализСайта',
          title: 'Автоматизированный анализ технического состояния сайта, индексации и санкций поисковых систем',
          description: 'По проекту на постоянной основе производится автоматизированная проверка откликов продвигаемых страниц, robots.txt, доступность для индексации и наличие в индексе продвигаемых страниц, изменение контента, сообщений и предупреждений в Яндекс Вебмастер и Google Search Console, корректность кодов счетчиков аналитики Яндекс Метрика и Google Analytics, оплата домена, проседание трафика на продвигаемых страницах и т.д. Далее результаты автоматического анализа прорабатываются оптимизатором.'
        },
        {
          id: 'РаботаПостоянная5_СоставлениеПлана',
          title: 'Составление плана работ для улучшения достигнутых результатов, KPI проекта, устранения возникших проблем',
          description: 'По проекту проведены работы в отчетный период по улучшению сайта согласно факторам ранжирования и составлен план работ на следующий месяц. Список данных работ представлен ниже.'
        }
      ]
    }
  },
  computed: {
    activeWorks () {
      return this.works.filter(i => this.data[i.id])
    }
  }
}
</script>

<style lang="scss" scoped>

ol {
  padding-inline-start: 17px;
}
</style>
